<div class="flex gap-2">
  <button tailBtn (click)="toggleAuto()" [class.active]="isAuto" *ngIf="hasAuto" i18n="@@width_height_auto">Auto</button>
  <input tailInput type="number" [(ngModel)]="value.value" [disabled]="disableValueField">
  <select tailInput class="appearance-none" [(ngModel)]="value.unit" [disabled]="isAuto">
    <option *ngFor="let unit of units" [value]="unit">
      {{getUnitLabel(unit)}}
    </option>
  </select>
</div>
